import { CheckBox } from "components/common/CheckBox";
import { IndicativeCalculationBanner } from "components/common/IndicativeCalculationBanner";
import { ParagraphText } from "components/common/ParagraphText";
import { VisibleSection } from "components/common/VisibleSection";
import { RepaymentOptionType } from "domain/indicativeRepaymentOptions";
import { SelectedTreatmentsDetails } from "domain/selectedTreatments";
import {
  IMORTANT_INFO_HEADING,
  CRH_IMORTANT_INFO_TITLE,
  IMORTANT_INFO_TEXT2,
  CRH_EXTEND_TERM_IMORTANT_INFO_TEXT3,
  IMORTANT_INFO_TEXT4,
  CRH_EXTEND_TERM_CHKBOX_TEXT,
  CRH_CHKBOX_TEXT,
  CRH_IMORTANT_INFO_TEXT3,
  IMPORTANT_INFO_NOTE,
  IMPORTANT_INFO_NOTES,
} from "./RequestRepaymentHoliday.const";
type CRHImportantInformationProps = {
  selectedTreatments: SelectedTreatmentsDetails;
  checked: boolean;
  onChecked: (checked: boolean) => void;
};
export const CRHImportantInformation = ({
  selectedTreatments,
  checked,
  onChecked,
}: CRHImportantInformationProps) => {
  const isJustCRH =
    selectedTreatments.repaymentOption?.optionType ===
    RepaymentOptionType.CRHWithoutExtendTerm;
  return (
    <VisibleSection visible={!!selectedTreatments.repaymentOption}>
      <div className="imp-info">
        <h3 className="zb-heading3">{IMORTANT_INFO_HEADING}</h3>
        <p>
          <strong>{CRH_IMORTANT_INFO_TITLE}</strong>
        </p>
        <ul>
          <li>
            <span>
              Your loan will continue to <strong>accrue interest</strong> that
              you will <strong>need to pay</strong> during the Capital repayment
              holiday
            </span>
          </li>
          <li>
            <span>{IMORTANT_INFO_TEXT2}</span>
          </li>
          <li>
            <span>
              {isJustCRH
                ? CRH_IMORTANT_INFO_TEXT3
                : CRH_EXTEND_TERM_IMORTANT_INFO_TEXT3}
            </span>
          </li>
          <li>
            <span>{IMORTANT_INFO_TEXT4}</span>
          </li>
        </ul>
        {isJustCRH ? (
          IMPORTANT_INFO_NOTE
        ) : (
          <ParagraphText list={IMPORTANT_INFO_NOTES} />
        )}

        <IndicativeCalculationBanner />
        <CheckBox
          confirmType
          id="checkbox"
          checked={checked}
          label={isJustCRH ? CRH_CHKBOX_TEXT : CRH_EXTEND_TERM_CHKBOX_TEXT}
          onChange={onChecked}
        />
      </div>
    </VisibleSection>
  );
};
